import { IDuration } from '@gsp/gusto-front-common'
import { Duration, DurationUnitCode } from '@gsp/gusto-telemat-api-model'

const formatDuration: (duration: IDuration) => Duration = duration =>
  duration.days > 0
    ? { quantity: duration.days, durationUnitCode: DurationUnitCode.DAYS }
    : { quantity: duration.months, durationUnitCode: DurationUnitCode.MONTHS }

export default formatDuration
